<template>
    <div id="containerSso" class="mb-4">
        <base-button-sso id="btnSsoGoogle"
                         :description="$t('signInWithGoogle')"
                         :src="google"
                         :click="loginGoogle">
        </base-button-sso>
        <base-button-sso v-if="!this.$store.state.isSaml"
                         id="btnSsoMicrosoft"
                         :description="$t('signInWithMicrosoft')"
                         :src="microsoft"
                         :click="loginMicrosoft">
        </base-button-sso>
        <base-button-sso v-if="this.$store.state.isSaml"
                         id="btnSsoSaml"
                         :description="$t('signInWithMicrosoft')"
                         :src="microsoft"
                         :click="loginSaml">
        </base-button-sso>
    </div>
</template>
<script>
    import BaseButtonSSO from './../bases/BaseButtonSSO'
    import SharedMixin from './../../mixins/SharedMethods'
    export default {
        name: 'TheContainerSSO',
        components: {
            'base-button-sso': BaseButtonSSO
        },
        data() {
            return {
                google: 'https://cdnorquestrabootstrap.zeev.it/latest/assets/icon/sso/google.svg',
                microsoft: 'https://cdnorquestrabootstrap.zeev.it/latest/assets/icon/sso/microsoft.svg'
            }
        },
        mixins: [SharedMixin],
        methods: {
            loginGoogle: function () {
                var win = window.open('', '_blank', 'width=800, height=600');
                win.document.write('Loading...');
                var self = this;
                let origin = self.$store.state.origin;
                if (!origin) {
                    win.close();
                    return;
                }
                self.isLoading = true;
                let persist = self.$store.state.login.persist;
                let integrationName = self.$store.state.integrationName;
                let codSystem = self.$store.state.codSystem;
                const baseURI = `Google/V1/SignIn?origin=${origin}&integrationName=${integrationName}&persist=${persist}`;
                this.$http.get(baseURI)
                    .then((result) => {
                        win.location.href = result.data;
                        var url;
                        var pollTimer = window.setInterval(function () {
                            try {
                                if (win.document.URL.indexOf("LoginAuthorized") != -1) {
                                    url = win.document.URL;
                                    window.clearInterval(pollTimer);
                                    win.document.write('Loading...');
                                    url = url.replace('#', '');
                                    self.$http.get(url + `&codSystem=${codSystem}&isLocal=true&persist=${persist}&origin=${origin}`)
                                        .then((result) => {
                                            win.close();
                                            if (!result.data) {
                                                console.log("Problama ao gerar o token");
                                                return;
                                            }

                                            if (result.data.authenticationResult.toUpperCase() === "SUCCESS")
                                                window.top.location.href = `${origin}/api/internal/services/2.0/authentication/sso/login?${result.data.result}&urlRedirect=${self.$store.state.urlRedirect}&lang=${self.$store.state.localization}&CodMobileAppCrypt=${self.$store.state.appCode}`;
                                            else {
                                                self.showAlert(result.data.authenticationResult, "danger")
                                                self.isLoading = false;
                                            }
                                        })
                                        .finally(function () {
                                            win.close();
                                        });

                                }
                            }
                            catch (e) {
                                if (e.message.includes("'URL' of undefined")) {
                                    window.clearInterval(pollTimer);
                                    self.isLoading = false;
                                    win.close();
                                    return;
                                }
                            }
                            if (win.closed) {
                                self.isLoading = false;
                                window.clearInterval(pollTimer);
                                return;
                            }
                        }, 1000);

                    })
                    .catch(function (error) {
                        self.isLoading = false
                        console.log(error);
                    })
            },
            loginMicrosoft: function () {
                var win = window.open('', '_blank', 'width=800, height=600');
                win.document.write('Loading...');
                var self = this;
                let origin = self.$store.state.origin;
                if (!origin) {
                    win.close();
                    return;
                }
                let persist = self.$store.state.login.persist;
                let codSystem = self.$store.state.codSystem;
                self.isLoading = true;
                let integrationName = this.$store.state.integrationName;
                const baseURI = `Microsoft/V1/SignIn?origin=${origin}&integrationName=${integrationName}&persist=${persist}`;
                this.$http.get(baseURI)
                    .then((result) => {
                        win.location.href = result.data;
                        var pollTimer = window.setInterval(function () {
                            try {
                                if (win.document.URL.indexOf("LoginAuthorized") != -1) {
                                    let url = win.document.URL;
                                    window.clearInterval(pollTimer);
                                    win.document.write('Loading...');
                                    url = url.replace('#', '');
                                    self.$http.get(url + `&codSystem=${codSystem}&isLocal=true&persist=${persist}&origin=${origin}`)
                                        .then((result) => {
                                            win.close();
                                            if (!result.data) {
                                                console.log("Problama ao gerar o token");
                                                return;
                                            }

                                            if (result.data.authenticationResult.toUpperCase() === "SUCCESS")
                                                window.top.location.href = `${origin}/api/internal/services/2.0/authentication/sso/login?${result.data.result}&urlRedirect=${self.$store.state.urlRedirect}&lang=${self.$store.state.localization}&CodMobileAppCrypt=${self.$store.state.appCode}`;
                                            else {
                                                self.showAlert(result.data.authenticationResult, "danger")
                                            }
                                        })
                                        .finally(function () {
                                            win.close();
                                        });

                                }
                            }
                            catch (e) {
                                if (e.message.includes("'URL' of undefined")) {
                                    window.clearInterval(pollTimer);
                                    win.close();
                                    self.isLoading = false;
                                    return;
                                }

                            }
                            if (win.closed) {
                                self.isLoading = false;
                                window.clearInterval(pollTimer);
                                return;
                            }
                        }, 1000);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.isLoading = false;
                    })
            },
            loginSaml: function () {
                var win = window.open('', '_blank', 'width=800, height=600');
                win.document.write('Loading...');
                var self = this;
                let origin = self.$store.state.origin;
                if (!origin) {
                    win.close();
                    return;
                }
                let persist = self.$store.state.login.persist;
                let codSystem = self.$store.state.codSystem;
                self.isLoading = true;
                let integrationName = this.$store.state.integrationName;
                let issuer = self.$store.state.samlIssuer;
                let metadata = self.$store.state.samlMetadata;
                const baseURI = `Saml/V1/SignIn?issuer=${issuer}&metadata=${metadata}`;
                this.$http.get(baseURI)
                    .then((result) => {
                        win.location.href = result.data;
                        var pollTimer = window.setInterval(function () {
                            try {
                                if (win.document.URL.indexOf("asc") != -1) {
                                    window.clearInterval(pollTimer);
                                    win.document.write('Loading...');
                                    self.$http.get(`Saml/V1/LoginAuthorized?state=${integrationName}&codSystem=${codSystem}&isLocal=true&persist=${persist}&origin=${origin}`)
                                        .then((result) => {
                                            win.close();
                                            if (!result.data) {
                                                console.log("Problama ao gerar o token");
                                                return;
                                            }

                                            if (result.data.authenticationResult.toUpperCase() === "SUCCESS")
                                                window.top.location.href = `${origin}/api/internal/services/2.0/authentication/sso/login?${result.data.result}&urlRedirect=${self.$store.state.urlRedirect}&lang=${self.$store.state.localization}&CodMobileAppCrypt=${self.$store.state.appCode}`;
                                            else {
                                                self.showAlert(result.data.authenticationResult, "danger")
                                            }
                                        })
                                        .finally(function () {
                                            win.close();
                                        });

                                }
                            }
                            catch (e) {
                                if (e.message.includes("'URL' of undefined")) {
                                    window.clearInterval(pollTimer);
                                    win.close();
                                    self.isLoading = false;
                                    return;
                                }

                            }
                            if (win.closed) {
                                self.isLoading = false;
                                window.clearInterval(pollTimer);
                                return;
                            }
                        }, 1000);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.isLoading = false;
                    })
            }
        }
    }
</script>
<style>
</style>